import React, { FC } from "react";
import {
  getPlayers,
  getPlayersWithRegistrations,
} from "../../features/player/playerSlice";
import { useAppSelector } from "../../store";
import { Players } from "../../types";
import BasePlayerSelector from "../Base/BasePlayerSelector";

type Props = {
  label: string;
  currentPlayerId: string | null;
  withRegistration?: boolean;
  onPlayerSelect: (player: Players | null) => void;
};

const PlayerSelector: FC<Props> = ({
  label,
  onPlayerSelect,
  currentPlayerId,
  withRegistration = false,
}) => {
  const playersWithoutRegistrations = useAppSelector<Players[]>(getPlayers);
  const playersWithRegistrations = useAppSelector<Players[]>(
    getPlayersWithRegistrations
  );

  const players: Players[] = withRegistration
    ? playersWithRegistrations
    : playersWithoutRegistrations;

  return (
    <BasePlayerSelector
      label={label}
      currentPlayerId={currentPlayerId}
      onPlayerSelect={onPlayerSelect}
      players={players}
      sx={{ flexGrow: 1 }}
    />
  );
};

export default PlayerSelector;
